const packs = [
  {
    icon: "ri-video-chat-line",
    name: "录屏切片资料包",
    size: "约 3.2 GB · 47 条",
    desc: "直播丑闻名场面完整录屏与关键切片，逐条附原始时间戳。",
    tone: "bg-accent-500 text-background-50",
  },
  {
    icon: "ri-chat-history-line",
    name: "聊天记录归档集",
    size: "约 680 MB · 128 组",
    desc: "按人物整理的对话截图与文字稿，支持关键词快速检索。",
    tone: "bg-secondary-600 text-background-50",
  },
  {
    icon: "ri-timeline-view",
    name: "事件时间线图表",
    size: "PDF · 实时更新",
    desc: "人物争议全流程一图看全，节点与证据链标注清晰。",
    tone: "bg-primary-600 text-background-50",
  },
];

export default function CtaDownload() {
  return (
    <section id="download" className="max-w-[1400px] mx-auto px-3 md:px-6 pt-10 md:pt-14 scroll-mt-20">
      <div className="relative overflow-hidden rounded-lg bg-background-900 px-4 md:px-8 py-8 md:py-10">
        <div className="pointer-events-none absolute -right-10 -top-14 h-56 w-56 rounded-full bg-primary-600/30 blur-3xl"></div>
        <div className="pointer-events-none absolute -bottom-16 -left-10 h-56 w-56 rounded-full bg-accent-500/20 blur-3xl"></div>

        <div className="relative flex flex-col lg:flex-row lg:items-end justify-between gap-5 pb-6">
          <div>
            <span className="inline-flex items-center gap-1 rounded bg-accent-500 text-background-50 px-2 py-0.5 text-[11px] whitespace-nowrap">
              <i className="ri-archive-2-fill w-3.5 h-3.5 flex items-center justify-center"></i>
              吃瓜素材包
            </span>
            <h2 className="font-heading text-xl md:text-3xl text-background-50 mt-2">证据包一键下载 · 看得见也拿得走</h2>
            <p className="text-[13px] md:text-sm text-background-300/90 mt-1 max-w-2xl">
              录屏切片、聊天记录、时间线图表按人物打包，追更这个瓜，一份资料包就够了。
            </p>
          </div>
          <div className="flex items-center gap-2 text-[12px] text-background-300">
            <i className="ri-lock-line w-4 h-4 flex items-center justify-center text-secondary-500"></i>
            打包内容仅作整理参考，请以原始来源为准
          </div>
        </div>

        <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {packs.map((p) => (
            <div key={p.name} className="flex flex-col gap-3 rounded-lg bg-background-50/5 border border-background-50/10 p-4 md:p-5 backdrop-blur">
              <div className="flex items-start justify-between gap-3">
                <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${p.tone}`}>
                  <i className={`${p.icon} text-xl w-6 h-6 flex items-center justify-center`}></i>
                </span>
                <span className="rounded bg-background-50/10 px-2 py-0.5 text-[11px] text-background-200 whitespace-nowrap">{p.size}</span>
              </div>
              <h3 className="font-heading text-base text-background-50">{p.name}</h3>
              <p className="text-[12px] text-background-300/90 leading-relaxed flex-1">{p.desc}</p>
              <a href="#rank" className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 text-primary-800 px-3 py-2.5 text-sm font-semibold hover:bg-accent-400 hover:text-background-50 transition-colors">
                <i className="ri-download-2-line w-4 h-4 flex items-center justify-center"></i>
                下载资料包
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}